import { createAction, handleActions } from 'redux-actions'
import { uniq } from 'lodash'

import { RESET_GAME } from './index'

export const CLICK_ITEM = 'BPF_4075/itemInteractions/CLICK_ITEM'
export const REMOVE_ITEMS_FOR_ROOM =
  'BPF_4075/itemInteractions/CLEAR_ITEMS_FOR_ROOM'

const initialState = {
  clickedItems: [],
  latestClickedItem: null,
}

export default handleActions(
  {
    // Reset all game state.
    [RESET_GAME]: () => ({ ...initialState }),

    // Adds an item by ID to the clicked items list.
    [CLICK_ITEM]: (state, { payload }) => ({
      ...state,
      latestClickedItem: payload,
      clickedItems: uniq(state.clickedItems.concat([payload])),
    }),

    // Removes all items by ID from the clicked items list prefixed with a room ID.
    [REMOVE_ITEMS_FOR_ROOM]: (state, { payload }) => ({
      ...state,
      clickedItems: state.clickedItems.filter(
        item => !item.startsWith(payload + '__'),
      ),
    }),
  },
  initialState,
)

export const clickItem = createAction(CLICK_ITEM)
export const removeItemsForRoom = createAction(REMOVE_ITEMS_FOR_ROOM)



// WEBPACK FOOTER //
// ./src/modules/itemInteractions.js